<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="80%"
      class="chartDia"
      @close="close"
      append-to-body
    >
      <div slot="title" class="slotTit">项目支付详情</div>
      <div class="search-box" v-if="!hideSearch">
        <div class="search-left">
          <div>
            <span>个体：</span>
            <el-input
              class="search-input"
              placeholder="请输入"
              v-model="searchQuery.geTienterpriseName"
              clearable
            ></el-input>
          </div>
          <div>
            <span>支付状态：</span>
            <el-select
              v-model="searchQuery.payStatus"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in projectOrderPayStatus2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <template v-if="$route.query.activeTask == 'finished'">
            <el-button type="primary" @click="handleDownAllPDF('all')">
              全部下载
            </el-button>
            <el-button
              type="primary"
              @click="handleDownAllPDF('selected')"
              :disabled="!selectedArr.length"
            >
              批量下载
            </el-button>
          </template>
        </div>
      </div>
      <el-table
        border
        style="width: 100%"
        row-key="orderPeopleId"
        ref="payTable"
        :stripe="true"
        :highlight-current-row="false"
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectable"
          reserve-selection
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          type="index"
          label="序号"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="full_name"
          label="经营者"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="geTienterpriseName"
          label="个体"
        >
          <template slot-scope="{ row }">
            <span v-if="row.geTienterpriseName">
              {{ row.geTienterpriseName }}
            </span>
            <span style="color:grey" v-else>完成支付后展示</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="bankNo"
          label="收款账号"
        >
          <template slot-scope="{ row }">
            <span v-if="row.collectMoneyType === 2">
              {{ row.zbBankCardNumber }}
            </span>
            <span v-else-if="row.bankNo">{{ row.bankNo }}</span>
            <span style="color:grey" v-else>完成支付后展示</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="收款类型"
        >
          <template slot-scope="scope">
            {{ scope.row.collectMoneyType | transCollectMoneyType }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="类别"
        >
          <template slot-scope="{ row }">
            {{ row.type == 1 ? '助手联盟' : '医学联盟' }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="finishSum"
          label="实际完成任务量"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端结算单价"
        >
          <template slot-scope="{ row }">
            <span v-if="row.projectType === 19">-</span>
            <span v-else>{{ row.taskPrice | moneyFixed }}</span>
            <!-- {{ row.projectType===19?'-':(row.taskPrice | moneyFixed) }} -->
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端结算金额"
        >
          <template slot-scope="{ row }">
            {{ row.totalPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付状态"
        >
          <template slot-scope="{ row }">{{ deal(row.payStatus) }}</template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" @click="check(row)">查看任务</el-button>
            <el-button
              :disabled="row.payStatus !== 2"
              type="text"
              @click="downloadFile(row)"
            >
              下载回单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px;text-align: center;"
      ></el-pagination>
      <el-button
        @click="close"
        type="primary"
        style="margin:0 auto;margin-top:20px;display:block;"
      >
        确认
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import {
  threeLevelProjectPayList,
  alreadyDownBack2,
  projectV2
} from '@/api/ajax';
import { projectOrderPayStatus2 } from '@/config/staticData';
import { mapActions } from 'vuex';
import receiptDownload from './receiptDownload.js';

export default {
  inject: {
    itemData: {
      default: {
        data: {}
      }
    }
  },
  mixins: [pageInation],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
    customDefaultQuery: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      projectOrderPayStatus2,
      getList: threeLevelProjectPayList, // 获取列表的AJAX
      showDetail: false,
      searchQuery: {
        id: this.itemData.data.id,
        geTienterpriseName: '',
        payStatus: ''
      },
      selectedArr: [] // 选择集合
    };
  },

  methods: {
    ...mapActions(['syncProjectInfo']),
    // 搜索时清空之前选项
    handleSearch() {
      this.$refs.payTable.clearSelection();
      this.searchEvent();
    },
    // 支付成功的可以被选中
    selectable({ payStatus }) {
      return payStatus === 2;
    },
    handleSelectionChange(v) {
      this.selectedArr = v;
    },
    handleDownAllPDF(type) {
      receiptDownload.call(this, {
        row: this.itemData.data,
        query: this.searchQuery,
        selectedType: type,
        selectedArr: this.selectedArr
      });
    },
    downloadFile(row) {
      //入参:String payOrderNo（订单号）,Long projectId,String taskDt,Long orderPeopleId(供应商id)
      try {
        let a = JSON.parse(localStorage.getItem('activeTask')) || {};
        let { orderPeopleId, taskDt } = row;
        let { projectName } = a;
        projectName = projectName || '';
        window.open(
          `${alreadyDownBack2}?orderPeopleId=${orderPeopleId}&projectName=${projectName}&taskDt=${taskDt}`
        );
      } catch (e) {
        console.error(e);
      }
    },
    deal(v) {
      return this.projectOrderPayStatus2[v].label;
    },
    async check(row) {
      row.id = row.projectId;
      let serviceSubitem = '';
      if (row.projectType == 20) {
        const {
          data: { data }
        } = await projectV2.getServiceSubitemByProjectId(row);
        serviceSubitem = (data || {}).serviceSubitem;
      }
      this.syncProjectInfo({
        ...row,
        serviceSubitem
      }).then(() => {
        const routeDate = this.$router.resolve({
          name: 'record',
          query: { id: row.id, fullName: row.full_name, taskDate: row.taskDt }
        });
        window.open(routeDate.href, '_blank');
      });
    },
    close() {
      this.$parent.componentName = '';
      this.$emit('close');
    }
  },
  filters: {
    fillBlank(v) {
      return v ? v : '';
    }
  },
  created() {
    if ('use' in this.customDefaultQuery) {
      delete this.customDefaultQuery.use;
      this.searchQuery = Object.assign(
        {},
        this.searchQuery,
        this.customDefaultQuery
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  position: relative;
  justify-content: space-around;
  // padding: 15px 0;
  margin-bottom: 2.18vw;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > * {
    margin-right: 10px;
  }

  .search-input,
  .el-date-editor--month,
  .search-select {
    width: 11.66vw;
    max-width: 224px;
    min-width: 149px;
  }

  .search-select,
  .el-date-editor,
  .el-button,
  .search-input {
    // margin-right: 1.56vw;
  }
  .el-button {
    //width: 4.6vw;
    //max-width: 88px;
    min-width: 70px;
  }

  /*搜索 左侧输入框*/
  .search-left {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -15px;
    align-items: flex-start;

    > div {
      margin-bottom: 15px;
      margin-right: 10px;
      > .el-cascader {
        /*解决此元素绝对定位影响父元素高度*/
        height: 40px;
      }
    }

    > div > span {
      width: 42px;
      height: 14px;
      font-size: 0.95em;
      font-weight: 400;
      color: rgba(74, 74, 74, 1);
      line-height: 14px;
      margin-right: 10px;
    }
  }

  /*搜索 右侧按钮盒子*/
  .search-right {
    align-self: normal;
    display: flex;
    align-items: flex-end;

    button {
      margin-right: 20px;
      margin-left: 0px;
    }

    button:last-child {
      margin-right: 0;
    }
  }

  .el-button {
    border-radius: 2px;
  }

  /*添加按钮绿色背景*/
  .button-green {
    background: #75c750;
    border-color: #75c750;
  }

  .button-origin {
    background: #de750a;
    border-color: #de750a;
  }
  .search-btns {
    display: flex;
  }
}
</style>
